import React from 'react';

const ServerContext = React.createContext();

export default ServerContext;
